import type { ExtensionAdoptionStatsData, ExtensionGovernanceUser } from "../types";

export const computeAdoptionStats = (users: ExtensionGovernanceUser[]): ExtensionAdoptionStatsData => {
    let activeUsers = 0;
    let inactive = 0;

    for (const user of users) {
        if (user.status === "Active") {
            activeUsers++;
        } else if (user.status === "Inactive") {
            inactive++;
        }
    }

    return {
        totalSeats: users.length,
        installs: activeUsers + inactive,
        activeUsers,
        notUsing: inactive,
    };
};
